import { render, staticRenderFns } from "./DiseaseMainPage.vue?vue&type=template&id=61c0df4e"
import script from "./DiseaseMainPage.vue?vue&type=script&lang=js"
export * from "./DiseaseMainPage.vue?vue&type=script&lang=js"
import style0 from "./DiseaseMainPage.vue?vue&type=style&index=0&id=61c0df4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports